import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectService } from '@catcore/services';
import {extractDataFromModel} from '@catcore/utils';
import {ProjectMediaSourcesService} from '@catmodules/models/project-media-sources/services/project-media-sources.service';
import {
  MediaSourceTableItem, MediaSourceUnit,
  ProjectMediaSources,
} from '@catmodules/models/project-media-sources/types';
import { Subscription } from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'cat-project-media-sources',
  templateUrl: './project-media-sources.component.html',
  styleUrls: ['./project-media-sources.component.scss'],
})
export class ProjectMediaSourcesComponent implements OnInit, OnDestroy {

  private mediaSourcesSubscription: Subscription;
  private projectSubscription: Subscription;
  private project = null;
  private tableItems: MediaSourceTableItem[] = [];
  dataTableInitialized = false;

  columns = {
    unit: {field: 'unit', header: 'Unit'},
    unitLoc: {field: 'unitLoc', header: 'Unit Location'},
    type: {field: 'type', header: 'Source Type'},
    service: {field: 'service', header: 'Service'},
    serviceLoc: {field: 'serviceLoc', header: 'Service Location'},
    mediaUrl: {field: 'mediaUrl', header: 'Media URL'},
    parentMediaUrl: {field: 'parentMediaUrl', header: 'Parent Media URL'},
  };

  constructor(private projectService: ProjectService,
              private projectMediaSourceService: ProjectMediaSourcesService) { }

  dataAvailable() {
    return !isNullOrUndefined(this.tableItems) && this.tableItems.length !== 0;
  }

  ngOnInit() {
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.dataTableInitialized = false;
          this.project = project;
          this.projectMediaSourceService.setActive();
          this.mediaSourcesSubscription = this.projectService.getMediaSources(this.project)
            .subscribe((mediaSources: ProjectMediaSources) => {
              if (!isNullOrUndefined(mediaSources)) {
                this.createDataTableItems(extractDataFromModel(mediaSources, 'item', '_embedded'));
                this.dataTableInitialized = true;
              }
          });
        }
      });
  }

  ngOnDestroy() {
    this.mediaSourcesSubscription.unsubscribe();
    this.projectSubscription.unsubscribe();
    this.projectMediaSourceService.setInActive();
  }

  private createDataTableItems(mediaSources) {
    mediaSources.forEach((mediaSource) => {
      const tmpService = extractDataFromModel(mediaSource, 'service', '_embedded');
      const unitInfo: MediaSourceUnit = extractDataFromModel(tmpService, 'unit', '_embedded');
      const data: MediaSourceTableItem = {
        unit: unitInfo.name,
        unitLoc: unitInfo.location_address,
        type: mediaSource.media_source_type,
        service: mediaSource.service_name,
        serviceLoc: mediaSource.location_id,
        mediaUrl: mediaSource.media_url_string,
        parentMediaUrl: ProjectMediaSourcesComponent.getParentMediaUrl(mediaSource),
      };
      this.tableItems.push(data);
    });
  }

  private static getParentMediaUrl(mediaSource) {
    if (mediaSource._embedded
      && mediaSource._embedded.parent_media_source) {
      return mediaSource._embedded.parent_media_source.media_url_string;
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-media-sources/components/project-media-sources/project-media-sources.component.ts